import { useEffect } from "react";
import { useToploaderContext } from "../../../context/TopLoaderContext";

const Fallback = () => {
  const { loader } = useToploaderContext();
  useEffect(() => {
    const loaderRef = loader;
    loaderRef?.current?.continuousStart();
    return () => {
      loaderRef?.current?.complete();
    };
  }, [loader]);
  return null;
};

export default Fallback;
